import {createAsyncThunk, createSlice} from "@reduxjs/toolkit";

import {clientsService} from "../../../services/clients-services";


const initialState = {
    clientsArray: [],
    searchClients: [],
    page: 1,
    status: null,
    error: null,
    trigger: 0,
    searchQuery: '',
    searchField: 'name',
}

const getSearchClients = createAsyncThunk(
    'clientsSlice/searchClients',
    async ({page, word, searchField = 'search'}, {rejectWithValue}) => {
        try {
            return await clientsService.searchClients(page, word, searchField);
        } catch (e) {
            return rejectWithValue(e.response?.data?.message || "Something went wrong");
        }
    }
);


const getAllClients = createAsyncThunk(
    'clientsSlice/getAllClients',
    async ({page}, {rejectWithValue}) => {
        try {
            return await clientsService.getAllClients(page);
        } catch (e) {
            return rejectWithValue(e.response?.data?.message || "Something went wrong");
        }
    }
);


const clientsSlice = createSlice({
    name: 'clientsSlice',
    initialState,
    reducers: {
        changeTrigger: (state, action) => {
            state.trigger = state.trigger + 1;
        },
        clearSearch: (state) => {
            state.searchClients = [];
            state.searchQuery = '';
        },
        setSearchQuery: (state, action) => {
            state.searchQuery = action.payload;
        },
        setSearchField: (state, action) => {
            state.searchField = action.payload;
        },
    },
    extraReducers: builder =>
        builder
            .addCase(getAllClients.pending, state => {
                state.status = 'Loading';
                state.error = null;
            })
            .addCase(getAllClients.fulfilled, (state, action) => {
                state.status = 'fulfilled';
                state.clientsArray = action.payload;
            })
            .addCase(getAllClients.rejected, (state, action) => {
                state.status = 'rejected';
                state.error = action.payload;
            })
            .addCase(getSearchClients.pending, state => {
                state.status = 'Loading';
                state.error = null;
            })
            .addCase(getSearchClients.fulfilled, (state, action) => {
                state.status = 'fulfilled';
                state.searchClients = action.payload;
            })
            .addCase(getSearchClients.rejected, (state, action) => {
                state.status = 'rejected';
                state.error = action.payload;
            })
});

const {reducer: clientsReducer, actions} = clientsSlice;
const clientsActions = {
    ...actions,
    getAllClients,
    getSearchClients,
}

export {
    clientsReducer,
    clientsActions,
}
